import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import Role from './components/Role';

export default function indexRole() {
    return (
      <>
        <MainContent titulo='Administración de Roles' component={ <Role /> } />        
        
        <Outlet />
      </>
    );      
}